module.exports = __webpack_public_path__ + "static/img/Shape@2xf72a7c7.png";